import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreAlarmLogsReportWizardFilters',
  props: {
    reportModel: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      editModel: null,
      smartGroupsFinishedLoading: false,
      smartGroupList: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    operationalStatusTexts: function operationalStatusTexts() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatuses: function operationalStatuses() {
      var _this = this;

      return Object.keys(this.operationalStatusTexts).map(function (os) {
        return {
          text: _this.operationalStatusTexts[os],
          value: parseInt(os)
        };
      });
    },
    logCategories: function logCategories() {
      return [this.editModel.filters.originType === 'virtual-device--health-state' ? {
        value: 'battery',
        text: this.$i18n_t('AlarmLogs.categories.battery')
      } : null, this.editModel.filters.originType === 'virtual-device--health-state' ? {
        value: 'connectivity',
        text: this.$i18n_t('AlarmLogs.categories.connectivity')
      } : null, this.editModel.filters.originType === 'virtual-device--health-state' ? {
        value: 'device',
        text: this.$i18n_t('AlarmLogs.categories.device')
      } : null, this.editModel.filters.originType !== 'virtual-device--health-state' ? {
        value: 'packet-threshold',
        text: this.$i18n_t('AlarmLogs.categories.packet-threshold')
      } : null].filter(function (c) {
        return c;
      });
    },
    requiredRule: function requiredRule() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('Common.fieldRequired');
      }];
    }
  }),
  watch: {
    reportModel: {
      handler: function handler() {
        this.editModel = cloneDeep(this.reportModel);
      },
      deep: true,
      immediate: true
    },
    'editModel.tenantId': {
      handler: function handler() {
        this.fetchSmartGroups();
      },
      immediate: true
    },
    editModel: {
      handler: function handler() {
        // only publish changes if an actual value did change, not just a new cloned instance got assigned
        if (JSON.stringify(this.editModel) !== JSON.stringify(this.reportModel)) {
          this.publishChanges();
        }
      },
      deep: true
    }
  },
  methods: {
    fetchSmartGroups: function fetchSmartGroups() {
      var _this3 = this;

      if (!get(this.editModel, 'tenantId')) {
        return;
      }

      this.smartGroupsFinishedLoading = false; // fetch groups filtered by the chosen account from step 1

      ApiService.virtualDeviceViewsFetch(this, {
        tenantIds: [this.editModel.tenantId]
      }).then(function (response) {
        _this3.smartGroupList = response;
      }).catch(function (error) {
        console.error(error);

        _this3.$snack(_this3.$i18n_t('DigitalTwin.VirtualDevice.snacks.loadMonitoringViewFailed'), 'error');
      }).finally(function () {
        _this3.smartGroupsFinishedLoading = true;
      });
    },
    publishChanges: debounce(function () {
      this.$emit('change', this.editModel);
    }, 250)
  }
};